<template>
  <v-container class="projects none-fluid">
    <banner>Research Projects</banner>
    <v-tabs background-color="transparent" color="rgb(153, 27, 30)" right>
      <v-tab @click="selected = 'current'">CURRENT</v-tab>
      <v-tab @click="selected = 'past'">PAST</v-tab>
    </v-tabs>
    <div class="all-projects-content mx-auto">
      <div v-if="selected === 'current'">
        <v-row>
          <v-col
            v-for="project in current"
            :key="project.id"
            cols="12"
            sm="6"
            md="4"
          >
            <v-hover v-slot="{ hover }">
              <v-card
                class="mx-auto"
                :href="
                  project.externalLink
                    ? project.externalLink
                    : '/project/' + project.id
                "
              >
              <!-- Class for the thummbnail image display: "contain" keyword scales image to fit in the thumbnail tile -->
                <v-img
                  class="white--text align-end"
                  height="300px"
                  contain
                  :src="
                    project.thumbnail ||
                    'https://firebasestorage.googleapis.com/v0/b/uscinteractionlab.appspot.com/o/projects%2Fproject_placeholder.png?alt=media&token=76d05851-6808-4854-a317-1b0c81da9506'
                  "
                >
                  <v-expand-transition>
                    <div
                      v-if="hover"
                      class="d-flex transition-fast-in-fast-out v-card--reveal caption"
                      style="height: 100%"
                    >
                      {{ project.summary }}
                    </div>
                  </v-expand-transition>
                </v-img>

                <v-card-text class="project-text">
                  {{ project.title }}
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <div v-for="project in past" :key="project.id" class="all-project-link">
          <a
            class="link"
            :href="
              project.externalLink
                ? project.externalLink
                : '/project/' + project.id
            "
          >
            {{ project.title }}
          </a>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import Banner from "../global/Banner";
import { getAllProjects } from "../../service/research/projects";

export default {
  components: {
    Banner,
  },
  data() {
    return {
      current: [],
      past: [],
      selected: "current",
    };
  },
  mounted() {
    getAllProjects()
      .then((data) => {
        const { current, past } = data;
        this.current = current;
        this.past = past;
      })
      .catch((err) => {
        console.error(err.message);
      });
  },
};
</script>

<style lang="scss">
.projects {
  .all-projects-content {
    .all-project-link {
      margin: 10px 0;
    }
  }
}

.project-text {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  min-height: 100px;
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.7;
  position: absolute;
  width: 100%;
  padding: 0 10%;
  background-color: rgb(153, 0, 0);
}

/**
 * following are responsive support
 */
@media (max-width: 420px) {
  .projects {
    .all-projects-content {
      .all-project-link {
        padding: 0;
        margin: 15px 0;
      }
    }

    .custom-tabs {
      position: relative;
      transform: none;
      margin-bottom: 30px;
    }
  }
}
</style>